// removed by extract-text-webpack-plugin
module.exports = {"codeBox":"_1NV77CgwJZnceXib5zRVx_","codeImg":"_5hf_ziGKKtCLhbW0LMI6G","button":"_1uUhJTf5kDz1_-9g60n7TR"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Login/LoginCaptchaModal/index.less
// module id = 382
// module chunks = 0